var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"inline-block"}},[(_vm.isExternal)?_c('div',_vm._g({staticClass:"svg-external-icon svg-icon",style:(_vm.styleExternalIcon)},_vm.$listeners)):_vm._e(),_c('svg',{class:_vm.svgClass,style:(_vm.svgStyle),attrs:{"aria-hidden":"true"},on:{"click":_vm.clickFun}},[_c('use',{attrs:{"xlink:href":_vm.iconName}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }